export const timelog = {
  timelog_form: {
    PDBShipRef: "",
    VesselName: "",
    PortType: "",
    PortName: "",
    BerthName: "",
    ETBDate: "",
    ETBTime: "",
    ETBDateTime: "",
    ETCDate: "",
    ETCTime: "",
    ETCDateTime: "",
    ETDDate: "",
    ETDTime: "",
    ETDDateTime: "",
    VesselArrivedatPortDate: "",
    VesselArrivedatPortTime: "",
    VesselArrivedatPortDateTime: "",
    NORTenderedDate: "",
    NORTenderedTime: "",
    NORTenderedDateTime: "",
    VesselDroppedAnchorAtAnchorageDate: "",
    VesselDroppedAnchorAtAnchorageTime: "",
    VesselDroppedAnchorAtAnchorageDateTime: "",
    FreePratiqueGrantedDate: "",
    FreePratiqueGrantedTime: "",
    FreePratiqueGrantedDateTime: "",
    NORAcceptedDate: "",
    NORAcceptedTime: "",
    NORAcceptedDateTime: "",
    AnchorAweighDate: "",
    AnchorAweighTime: "",
    AnchorAweighDateTime: "",
    PilotOnBoardForBerthingDate: "",
    PilotOnBoardForBerthingTime: "",
    PilotOnBoardForBerthingDateTime: "",
    MotherShipDate: "",
    MotherShipTime: "",
    MotherShipDateTime: "",
    AllLineMadeFastDate: "",
    AllLineMadeFastTime: "",
    AllLineMadeFastDateTime: "",
    GangwayDownDate: "",
    GangwayDownTime: "",
    GangwayDownDateTime: "",
    PilotAwayBerthDate: "",
    PilotAwayBerthTime: "",
    PilotAwayBerthDateTime: "",
    LoadingMasterOnboardDate: "",
    LoadingMasterOnboardTime: "",
    LoadingMasterOnboardDateTime: "",
    SafetyMeetingCommencedDate: "",
    SafetyMeetingCommencedTime: "",
    SafetyMeetingCommencedDateTime: "",
    ArmConnectedProduct1Date: "",
    ArmConnectedProduct1Time: "",
    ArmConnectedProduct1DateTime: "",
    ArmConnectedProduct2Date: "",
    ArmConnectedProduct2Time: "",
    ArmConnectedProduct2DateTime: "",
    ArmConnectedProduct3Date: "",
    ArmConnectedProduct3Time: "",
    ArmConnectedProduct3DateTime: "",
    ArmConnectedProduct4Date: "",
    ArmConnectedProduct4Time: "",
    ArmConnectedProduct4DateTime: "",
    ArmConnectedProduct5Date: "",
    ArmConnectedProduct5Time: "",
    ArmConnectedProduct5DateTime: "",
    ArmConnectedProduct6Date: "",
    ArmConnectedProduct6Time: "",
    ArmConnectedProduct6DateTime: "",
    ArmConnectedProduct7Date: "",
    ArmConnectedProduct7Time: "",
    ArmConnectedProduct7DateTime: "",
    ArmConnectedProduct8Date: "",
    ArmConnectedProduct8Time: "",
    ArmConnectedProduct8DateTime: "",
    CommencedProduct1Date: "",
    CommencedProduct1Time: "",
    CommencedProduct1DateTime: "",
    CommencedProduct2Date: "",
    CommencedProduct2Time: "",
    CommencedProduct2DateTime: "",
    CommencedProduct3Date: "",
    CommencedProduct3Time: "",
    CommencedProduct3DateTime: "",
    CommencedProduct4Date: "",
    CommencedProduct4Time: "",
    CommencedProduct4DateTime: "",
    CommencedProduct5Date: "",
    CommencedProduct5Time: "",
    CommencedProduct5DateTime: "",
    CommencedProduct6Date: "",
    CommencedProduct6Time: "",
    CommencedProduct6DateTime: "",
    CommencedProduct7Date: "",
    CommencedProduct7Time: "",
    CommencedProduct7DateTime: "",
    CommencedProduct8Date: "",
    CommencedProduct8Time: "",
    CommencedProduct8DateTime: "",
    CompletedProduct1Date: "",
    CompletedProduct1Time: "",
    CompletedProduct1DateTime: "",
    CompletedProduct2Date: "",
    CompletedProduct2Time: "",
    CompletedProduct2DateTime: "",
    CompletedProduct3Date: "",
    CompletedProduct3Time: "",
    CompletedProduct3DateTime: "",
    CompletedProduct4Date: "",
    CompletedProduct4Time: "",
    CompletedProduct4DateTime: "",
    CompletedProduct5Date: "",
    CompletedProduct5Time: "",
    CompletedProduct5DateTime: "",
    CompletedProduct6Date: "",
    CompletedProduct6Time: "",
    CompletedProduct6DateTime: "",
    CompletedProduct7Date: "",
    CompletedProduct7Time: "",
    CompletedProduct7DateTime: "",
    CompletedProduct8Date: "",
    CompletedProduct8Time: "",
    CompletedProduct8DateTime: "",
    ArmDisconnectedProduct1Date: "",
    ArmDisconnectedProduct1Time: "",
    ArmDisconnectedProduct1DateTime: "",
    ArmDisconnectedProduct2Date: "",
    ArmDisconnectedProduct2Time: "",
    ArmDisconnectedProduct2DateTime: "",
    ArmDisconnectedProduct3Date: "",
    ArmDisconnectedProduct3Time: "",
    ArmDisconnectedProduct3DateTime: "",
    ArmDisconnectedProduct4Date: "",
    ArmDisconnectedProduct4Time: "",
    ArmDisconnectedProduct4DateTime: "",
    ArmDisconnectedProduct5Date: "",
    ArmDisconnectedProduct5Time: "",
    ArmDisconnectedProduct5DateTime: "",
    ArmDisconnectedProduct6Date: "",
    ArmDisconnectedProduct6Time: "",
    ArmDisconnectedProduct6DateTime: "",
    ArmDisconnectedProduct7Date: "",
    ArmDisconnectedProduct7Time: "",
    ArmDisconnectedProduct7DateTime: "",
    ArmDisconnectedProduct8Date: "",
    ArmDisconnectedProduct8Time: "",
    ArmDisconnectedProduct8DateTime: "",
    CargoDocumentsOnBoardDate: "",
    CargoDocumentsOnBoardTime: "",
    CargoDocumentsOnBoardDateTime: "",
    PilotOnBoardForDepartureDate: "",
    PilotOnBoardForDepartureTime: "",
    PilotOnBoardForDepartureDateTime: "",
    UnmooringDate: "",
    UnmooringTime: "",
    UnmooringDateTime: "",
    VesselCastOffDate: "",
    VesselCastOffTime: "",
    VesselCastOffDateTime: "",
    PilotAwayDepDate: "",
    PilotAwayDepTime: "",
    PilotAwayDepDateTime: "",
    FullAwayDate: "",
    FullAwayTime: "",
    FullAwayDateTime: "",
    NSA1: "",
    NSA1FromDate: "",
    NSA1FromTime: "",
    NSA1FromDateTime: "",
    NSA1ToDate: "",
    NSA1ToTime: "",
    NSA1ToDateTime: "",
    NSA2: "",
    NSA2FromDate: "",
    NSA2FromTime: "",
    NSA2FromDateTime: "",
    NSA2ToDate: "",
    NSA2ToTime: "",
    NSA2ToDateTime: "",
    NSA3: "",
    NSA3FromDate: "",
    NSA3FromTime: "",
    NSA3FromDateTime: "",
    NSA3ToDate: "",
    NSA3ToTime: "",
    NSA3ToDateTime: "",
    NSA4: "",
    NSA4FromDate: "",
    NSA4FromTime: "",
    NSA4FromDateTime: "",
    NSA4ToDate: "",
    NSA4ToTime: "",
    NSA4ToDateTime: "",
    NSA5: "",
    NSA5FromDate: "",
    NSA5FromTime: "",
    NSA5FromDateTime: "",
    NSA5ToDate: "",
    NSA5ToTime: "",
    NSA5ToDateTime: "",
    NSA6: "",
    NSA6FromDate: "",
    NSA6FromTime: "",
    NSA6FromDateTime: "",
    NSA6ToDate: "",
    NSA6ToTime: "",
    NSA6ToDateTime: "",
    NSA7: "",
    NSA7FromDate: "",
    NSA7FromTime: "",
    NSA7FromDateTime: "",
    NSA7ToDate: "",
    NSA7ToTime: "",
    NSA7ToDateTime: "",
    NSA8: "",
    NSA8FromDate: "",
    NSA8FromTime: "",
    NSA8FromDateTime: "",
    NSA8ToDate: "",
    NSA8ToTime: "",
    NSA8ToDateTime: "",
    NSA9: "",
    NSA9FromDate: "",
    NSA9FromTime: "",
    NSA9FromDateTime: "",
    NSA9ToDate: "",
    NSA9ToTime: "",
    NSA9ToDateTime: "",
    NSA10: "",
    NSA10FromDate: "",
    NSA10FromTime: "",
    NSA10FromDateTime: "",
    NSA10ToDate: "",
    NSA10ToTime: "",
    NSA10ToDateTime: "",
    Stoppages1: "",
    Stoppages1FromDate: "",
    Stoppages1FromTime: "",
    Stoppages1FromDateTime: "",
    Stoppages1ToDate: "",
    Stoppages1ToTime: "",
    Stoppages1ToDateTime: "",
    Stoppages2: "",
    Stoppages2FromDate: "",
    Stoppages2FromTime: "",
    Stoppages2FromDateTime: "",
    Stoppages2ToDate: "",
    Stoppages2ToTime: "",
    Stoppages2ToDateTime: "",
    Stoppages3: "",
    Stoppages3FromDate: "",
    Stoppages3FromTime: "",
    Stoppages3FromDateTime: "",
    Stoppages3ToDate: "",
    Stoppages3ToTime: "",
    Stoppages3ToDateTime: "",
    Stoppages4: "",
    Stoppages4FromDate: "",
    Stoppages4FromTime: "",
    Stoppages4FromDateTime: "",
    Stoppages4ToDate: "",
    Stoppages4ToTime: "",
    Stoppages4ToDateTime: "",
    Stoppages5: "",
    Stoppages5FromDate: "",
    Stoppages5FromTime: "",
    Stoppages5FromDateTime: "",
    Stoppages5ToDate: "",
    Stoppages5ToTime: "",
    Stoppages5ToDateTime: "",
    Stoppages6: "",
    Stoppages6FromDate: "",
    Stoppages6FromTime: "",
    Stoppages6FromDateTime: "",
    Stoppages6ToDate: "",
    Stoppages6ToTime: "",
    Stoppages6ToDateTime: "",
    Stoppages7: "",
    Stoppages7FromDate: "",
    Stoppages7FromTime: "",
    Stoppages7FromDateTime: "",
    Stoppages7ToDate: "",
    Stoppages7ToTime: "",
    Stoppages7ToDateTime: "",
    Stoppages8: "",
    Stoppages8FromDate: "",
    Stoppages8FromTime: "",
    Stoppages8FromDateTime: "",
    Stoppages8ToDate: "",
    Stoppages8ToTime: "",
    Stoppages8ToDateTime: "",
    Stoppages9: "",
    Stoppages9FromDate: "",
    Stoppages9FromTime: "",
    Stoppages9FromDateTime: "",
    Stoppages9ToDate: "",
    Stoppages9ToTime: "",
    Stoppages9ToDateTime: "",
    Stoppages10: "",
    Stoppages10FromDate: "",
    Stoppages10FromTime: "",
    Stoppages10FromDateTime: "",
    Stoppages10ToDate: "",
    Stoppages10ToTime: "",
    Stoppages10ToDateTime: "",
    Product1: "",
    Product2: "",
    Product3: "",
    Product4: "",
    Product5: "",
    Product6: "",
    Product7: "",
    Product8: "",
    CreatedTimestamp: "",
    ModifiedTimestamp: "",
    SurveyorOnboardDate: "",
    SurveyorOnboardTime: "",
    SurveyorOnboardDateTime: "",
    TankInspectionCommencedDate: "",
    TankInspectionCommencedTime: "",
    TankInspectionCommencedDateTime: "",
    TankInspectionCompletedDate: "",
    TankInspectionCompletedTime: "",
    TankInspectionCompletedDateTime: "",
    UllagingCommencedDate: "",
    UllagingCommencedTime: "",
    UllagingCommencedDateTime: "",
    UllagingCompletedDate: "",
    UllagingCompletedTime: "",
    UllagingCompletedDateTime: "",
    CalculationCompletedDate: "",
    CalculationCompletedTime: "",
    CalculationCompletedDateTime: "",
    FiguresAgreedDate: "",
    FiguresAgreedTime: "",
    FiguresAgreedDateTime: "",
    SSSCLCompletedDate: "",
    SSSCLCompletedTime: "",
    SSSCLCompletedDateTime: "",
    SurveyorCompany: "",
    ReportStatus: "",
    ReportFilename: "",
    DateCreated: "",
    DateModify: "",
    ModifyBy: "",
    PilotBookingTimeBerthingDate: "",
    PilotBookingTimeBerthingTime: "",
    PilotBookingTimeBerthingDateTime: "",
    ShiftingToBerthDate: "",
    ShiftingToBerthTime: "",
    ShiftingToBerthDateTime: "",
    ToppingOffDate: "",
    ToppingOffTime: "",
    ToppingOffDateTime: "",
    DocumentsCompletedDate: "",
    DocumentsCompletedTime: "",
    DocumentsCompletedDateTime: "",
    PortClearanceObtainedDate: "",
    PortClearanceObtainedTime: "",
    PortClearanceObtainedDateTime: "",
    PilotBookingTimeUnberthingDate: "",
    PilotBookingTimeUnberthingTime: "",
    PilotBookingTimeUnberthingDateTime: "",
    AgentCompany: "",
    FiguresSubmittedDate: "",
    FiguresSubmittedTime: "",
    FiguresSubmittedDateTime: "",
    CustomDeclarationCompletedDate: "",
    CustomDeclarationCompletedTime: "",
    CustomDeclarationCompletedDateTime: "",
    PortClearanceOnboardDate: "",
    PortClearanceOnboardTime: "",
    PortClearanceOnboardDateTime: "",
    BerthOthers: "",
    AgentName: "",
    SurveyorName: "",
    ETADateTime: ""
  },
  is_data_loading: false,
  is_submit_loading: false,
  is_form_loading: false,
  is_show_pdf: false,
  tabs_index: 0,
  discharge_product: {
    Discharge1Product1: "",
    Discharge1Product2: "",
    Discharge1Product3: "",
    Discharge1Product4: "",
    Discharge1Product5: "",
    Discharge1Product6: "",
    Discharge1Product7: "",
    Discharge1Product8: "",
    Discharge2Product1: "",
    Discharge2Product2: "",
    Discharge2Product3: "",
    Discharge2Product4: "",
    Discharge2Product5: "",
    Discharge2Product6: "",
    Discharge2Product7: "",
    Discharge2Product8: "",
    Discharge3Product1: "",
    Discharge3Product2: "",
    Discharge3Product3: "",
    Discharge3Product4: "",
    Discharge3Product5: "",
    Discharge3Product6: "",
    Discharge3Product7: "",
    Discharge3Product8: "",
  },
  product_data: {
    product1: "",
    product2: "",
    product3: "",
    product4: "",
    product5: "",
    product6: "",
    product7: "",
    product8: "",
  },
  read_data: {},
  read_data_2: {},
  base64Pdf: null,
};



// WEBPACK FOOTER //
// ./src/reducers/timelog/timelog.state.js